import {LeaveTypeBalanceQualifier} from '../../../leavesReport/LeaveReportConfig'
import messageResource from '../../../../messageResource'

export default function LeaveCSVPreviewBalanceColumnsRender(){}

LeaveCSVPreviewBalanceColumnsRender.prototype.init = function(balanceQualifier){

    this.isNeedSickDays = balanceQualifier === LeaveTypeBalanceQualifier.SICK_DAYS_ONLY || balanceQualifier === LeaveTypeBalanceQualifier.PTO_AND_SICK_DAYS
    this.isNeedPTODays = balanceQualifier === LeaveTypeBalanceQualifier.PTO_ONLY || balanceQualifier === LeaveTypeBalanceQualifier.PTO_AND_SICK_DAYS
    return this;
};

LeaveCSVPreviewBalanceColumnsRender.prototype.addHeaderBalancesCells = function( row ){
    if(this.isNeedPTODays){
        this._addBalanceCells("report.leaves.pto_column.preview.csv.date_range.pto", SystemSettings.showPTOInHours, row);
    }
    if(this.isNeedSickDays){
        this._addBalanceCells("report.leaves.pto_column.preview.csv.date_range.sick_days", SystemSettings.showSickInHours, row);
    }
};

LeaveCSVPreviewBalanceColumnsRender.prototype.getNumberOfDataBalancesCells = function(){
    let num = 0
    if(this.isNeedPTODays){
        num += 2;
    }
    if(this.isNeedSickDays){
        num += 2;
    }
    return num;
};

LeaveCSVPreviewBalanceColumnsRender.prototype._addBalanceCells = function(balanceLabelKey, inHours, row){
    ReportPreviewUtils.addCreatedCell(
        row,
        ReportPreviewUtils.createCell(
            messageResource.getMessage(
                balanceLabelKey,
                [messageResource.getMessage("report.leaves.pto_column.beginning_date"), this._getHoursOrDaysMessage(inHours)])
        )
    );

    ReportPreviewUtils.addCreatedCell(
        row,
        ReportPreviewUtils.createCell(
            messageResource.getMessage(
                balanceLabelKey,
                [messageResource.getMessage("report.leaves.pto_column.ending_date"), this._getHoursOrDaysMessage(inHours)])
        )
    );
};

LeaveCSVPreviewBalanceColumnsRender.prototype._getHoursOrDaysMessage = function( inHours ) {
    if( inHours ){
        return messageResource.getMessage("common.pto_units.hours");
    } else {
        return messageResource.getMessage("common.pto_units.days");
    }
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/leave/LeaveCSVPreviewBalanceColumnsRender.js